module.exports = __webpack_public_path__ + "static/media/save.222d71ae.svg";